import React from 'react';

// project-imports
import { slugify } from '../../utils';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import PostOne from '../../components/post/PostOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';

// third-party
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const TagArchive = () => {

    // property initialization
    const { slug } = useParams();

    // Reading store data
    const blogData = useSelector(data => (data.blog.blogs));

    // Constant variable
    const data = (blogData || []).map(blog => {
        return {
            ...blog,
            tags: (blog.tags || []).filter(tagItem => slugify(tagItem) === slug)
        }
    }).filter(blog => blog.tags.length > 0);

    const tagTitle = data[0].tags[0];

    return (
        <>
            <SEO title={`Longswitch Academy Blogs On ${tagTitle} tag`} url={ process.env.PUBLIC_URL + `/category/${slugify(tagTitle)}`} />
            <Layout>
                <BreadcrumbOne
                    title={tagTitle}
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl={`Posts On ${tagTitle} tag`}
                />
                <div className="edu-elements-area edu-section-gap bg-color-white">
                    <div className="container mb--80">
                        <div className="row g-5">
                            <div className="col-lg-12">
                                <div className="row g-5">
                                    {
                                        data.map((item) => (
                                            <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                <PostOne data={item} />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default TagArchive;